import { c as _c } from "react/compiler-runtime";
import { AriaRole, PropsWithChildren } from "react";
import clsx from "classnames";
interface IButtonProps {
  href?: string;
  onClick?: () => any;
  type?: "alert" | "icon" | "basic" | "bold";
  withDivider?: boolean;
  role?: AriaRole;
  ariaLabel?: string;
  ariaExpanded?: boolean;
}
export const Button = props => {
  "use memo";

  const $ = _c(20);
  const {
    href,
    children,
    type,
    withDivider,
    onClick,
    role,
    ariaLabel,
    ariaExpanded
  } = props;
  const buttonType = type ?? "basic";
  const t0 = buttonType === "alert";
  const t1 = buttonType !== "alert";
  const t2 = buttonType === "icon";
  const t3 = buttonType !== "icon";
  const t4 = buttonType === "bold";
  let t5;
  if ($[0] !== t0 || $[1] !== t1 || $[2] !== t2 || $[3] !== t3 || $[4] !== t4 || $[5] !== withDivider) {
    t5 = clsx("inline-flex items-center text-xs transition", {
      "border-r border-gray-200": withDivider,
      "bg-red-500 font-bold text-white hover:bg-red-700": t0,
      "text-black hover:bg-gray-50": t1,
      "px-2": t2,
      "px-2.5 py-3.5 max-sm:px-2!": t3,
      "font-bold": t4
    });
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
    $[5] = withDivider;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const className = t5;
  if (href) {
    let t6;
    if ($[7] !== ariaLabel || $[8] !== children || $[9] !== className || $[10] !== href || $[11] !== role) {
      t6 = <a href={href} className={className} role={role} aria-label={ariaLabel}>{children}</a>;
      $[7] = ariaLabel;
      $[8] = children;
      $[9] = className;
      $[10] = href;
      $[11] = role;
      $[12] = t6;
    } else {
      t6 = $[12];
    }
    return t6;
  }
  let t6;
  if ($[13] !== ariaExpanded || $[14] !== ariaLabel || $[15] !== children || $[16] !== className || $[17] !== onClick || $[18] !== role) {
    t6 = <button onClick={onClick} className={className} role={role} aria-label={ariaLabel} aria-expanded={ariaExpanded}>{children}</button>;
    $[13] = ariaExpanded;
    $[14] = ariaLabel;
    $[15] = children;
    $[16] = className;
    $[17] = onClick;
    $[18] = role;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  return t6;
};